/* Ultrax — shared storefront behavior. App forms and scripts retain control of their own lifecycle. */
(function () {
  'use strict';
  if (window.__ultraxThemeInitialized) return;
  window.__ultraxThemeInitialized = true;

  var CFG = window.Ultrax || {};
  var MONEY_FORMAT = CFG.moneyFormat || '${{amount}}';
  var products = new WeakMap();
  var headers = new WeakSet();
  var pendingForms = new WeakSet();
  var desktop = window.matchMedia('(min-width: 990px)');
  var menuId = 0;
  var savedOverflow = null;
  var cartRequest = null;
  var cartRefreshTimer = null;
  /* Ligne « Shipping insurance » : ce n'est pas un produit, la pastille du panier ne la compte pas. */
  var PROTECTION_VARIANT_ID = 58298519945560;

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var formats = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.'],
      amount_with_apostrophe_separator: [2, "'", '.']
    };
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = MONEY_FORMAT.match(placeholder);
    var spec = formats[match && match[1]] || formats.amount;
    var parts = (cents / 100).toFixed(spec[0]).split('.');
    var amount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + spec[1]) + (parts[1] ? spec[2] + parts[1] : '');
    var template = document.createElement('template');
    template.innerHTML = MONEY_FORMAT.replace(placeholder, amount);
    return template.content.textContent;
  }

  function focusable(root) {
    return Array.from(root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'))
      .filter(function (node) { return !node.closest('[inert]') && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden'; });
  }

  function setMenu(header, open, restoreFocus) {
    var menu = header.querySelector('[data-menu]');
    if (!menu) return;
    open = Boolean(open && !desktop.matches);
    header.classList.toggle('menu-open', open);
    header.querySelectorAll('[data-menu-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-controls', menu.id);
    });
    menu.inert = !desktop.matches && !open;
    menu.setAttribute('aria-hidden', String(!desktop.matches && !open));
    if (open) {
      if (savedOverflow === null) savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      (focusable(menu)[0] || menu).focus({ preventScroll: true });
    } else {
      if (savedOverflow !== null && !document.querySelector('[data-header].menu-open')) {
        document.body.style.overflow = savedOverflow;
        savedOverflow = null;
      }
      if (restoreFocus) {
        var toggle = header.querySelector('.header__burger') || header.querySelector('[data-menu-toggle]');
        if (toggle && toggle.getClientRects().length) toggle.focus({ preventScroll: true });
      }
    }
  }

  function initHeader(header) {
    if (headers.has(header)) return;
    headers.add(header);
    var menu = header.querySelector('[data-menu]');
    if (!menu) return;
    if (!menu.id) menu.id = 'UltraxMenu-' + (++menuId);
    menu.setAttribute('tabindex', '-1');
    setMenu(header, false, false);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      var header = toggle.closest('[data-header]');
      if (header) {
        event.preventDefault();
        initHeader(header);
        setMenu(header, !header.classList.contains('menu-open'), true);
      }
      return;
    }
    var overlay = event.target.closest('[data-menu-overlay]');
    var link = event.target.closest('[data-menu] a[href]');
    if (overlay || link) {
      var openHeader = (overlay || link).closest('[data-header]');
      if (openHeader) setMenu(openHeader, false, Boolean(overlay));
    }
  });

  document.addEventListener('keydown', function (event) {
    var header = document.querySelector('[data-header].menu-open');
    if (!header) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setMenu(header, false, true);
    } else if (event.key === 'Tab') {
      var menu = header.querySelector('[data-menu]');
      var items = focusable(menu);
      var first = items[0];
      var last = items[items.length - 1];
      if (!first) { event.preventDefault(); menu.focus(); }
      else if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  });

  desktop.addEventListener('change', function () {
    document.querySelectorAll('[data-header]').forEach(function (header) { setMenu(header, false, false); });
  });

  function ajaxUrl(path) {
    return path.replace(/\.js(?=\?|$)/, '').replace(/\/$/, '') + '.js';
  }

  function cartUrl() {
    return ajaxUrl(CFG.cartUrl || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart');
  }

  function applyCartCount(cart) {
    if (!cart || !Number.isFinite(Number(cart.item_count))) return;
    var count = Array.isArray(cart.items) ? cart.items.reduce(function (total, item) {
      return total + (Number(item.variant_id) === PROTECTION_VARIANT_ID ? 0 : Number(item.quantity) || 0);
    }, 0) : Math.max(0, Number(cart.item_count));
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.hidden = count === 0;
    });
  }

  function refreshCartCount() {
    if (cartRequest) return cartRequest;
    cartRequest = fetch(cartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart');
        return response.json();
      })
      .then(function (cart) { applyCartCount(cart); return cart; })
      .catch(function () { return null; })
      .finally(function () { cartRequest = null; });
    return cartRequest;
  }

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:change:complete'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var cart = event.detail && (event.detail.cart || event.detail);
      if (cart && Number.isFinite(Number(cart.item_count))) applyCartCount(cart);
      else {
        clearTimeout(cartRefreshTimer);
        cartRefreshTimer = setTimeout(refreshCartCount, 80);
      }
    });
  });

  /* Depuis le 24/10/2026 le panier est celui du thème (assets/zl-cart-drawer.js, qui remplace Kaching Cart).
     Il intercepte lui-même l'envoi des formulaires form[action$="/cart/add"] et le clic sur l'icône panier :
     ici, rien ne doit les bloquer (un preventDefault couperait le tiroir). La pastille du header suit les
     ajouts et changements faits en arrière-plan, et se recalcule au retour arrière. */
  (function watchCartRequests() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function' || nativeFetch.__zlCartWatch) return;
    function watchedFetch(input, init) {
      var request = nativeFetch.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          request.then(function (response) {
            if (!response.ok) return;
            clearTimeout(cartRefreshTimer);
            cartRefreshTimer = setTimeout(refreshCartCount, 120);
          }, function () {});
        }
      } catch (error) { /* la requête de l'app part toujours telle quelle */ }
      return request;
    }
    watchedFetch.__zlCartWatch = true;
    window.fetch = watchedFetch;
  })();
  window.addEventListener('pageshow', function (event) {
    var entry = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (event.persisted || (entry && entry.type === 'back_forward')) refreshCartCount();
  });

  function initProduct(section) {
    if (products.has(section)) return;
    var json = section.querySelector('[data-product-json]');
    var variants;
    try { variants = JSON.parse(json ? json.textContent : '[]'); } catch (error) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    var idInput = section.querySelector('[data-variant-id]');
    var button = section.querySelector('[data-atc]');
    var text = section.querySelector('[data-atc-text]');
    var priceCurrent = section.querySelector('[data-price-current]');
    var priceWas = section.querySelector('[data-price-was]');
    var mainImage = section.querySelector('.product__main-img');
    var selects = Array.from(section.querySelectorAll('[data-option-index]'));
    var state = { available: false, label: '' };
    products.set(section, state);

    function currentVariant() {
      if (!selects.length) return variants.find(function (variant) { return String(variant.id) === String(idInput && idInput.value); }) || variants[0];
      return variants.find(function (variant) {
        return selects.every(function (select, index) { return variant.options[Number(select.dataset.optionIndex) || index] === select.value; });
      });
    }

    function image(source, alt) {
      if (!source || !mainImage || mainImage.tagName !== 'IMG') return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = source;
      if (alt) mainImage.alt = alt;
      section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        var selected = thumb.getAttribute('data-thumb').split('?')[0] === source.split('?')[0];
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-pressed', String(selected));
      });
    }

    function update() {
      var variant = currentVariant();
      state.available = Boolean(variant && variant.available);
      state.label = !variant ? ((CFG.strings && CFG.strings.unavailable) || 'Unavailable')
        : state.available ? ((CFG.strings && CFG.strings.addToCart) || 'Add to cart')
        : ((CFG.strings && CFG.strings.soldOut) || 'Sold out');
      if (idInput) idInput.value = variant ? variant.id : '';
      if (button) button.disabled = !state.available || pendingForms.has(button.form);
      if (text && !pendingForms.has(button && button.form)) text.textContent = state.label;
      if (!variant) return;
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      if (priceWas) {
        var sale = variant.compare_at_price > variant.price;
        priceWas.textContent = sale ? formatMoney(variant.compare_at_price) : '';
        priceWas.style.display = sale ? '' : 'none';
      }
      if (variant.featured_image) image(variant.featured_image.src, variant.featured_image.alt);
    }

    state.update = update;
    section.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-index]')) update();
    });
    section.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-thumb]');
      if (thumb && section.contains(thumb)) image(thumb.getAttribute('data-thumb'), thumb.querySelector('img') && thumb.querySelector('img').alt);
    });
    section.querySelectorAll('[data-thumb]').forEach(function (thumb) { thumb.setAttribute('aria-pressed', String(thumb.classList.contains('is-active'))); });
    update();
  }

  function init(root) {
    if (root instanceof Element && root.matches('[data-header]')) initHeader(root);
    if (root instanceof Element && root.matches('[data-product]')) initProduct(root);
    root.querySelectorAll('[data-header]').forEach(initHeader);
    root.querySelectorAll('[data-product]').forEach(initProduct);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var header = event.target.matches('[data-header].menu-open') ? event.target : event.target.querySelector('[data-header].menu-open');
    if (header) setMenu(header, false, false);
  });
  function start() {
    init(document);
    /* Shopify rend la pastille avec cart.item_count, ligne « Shipping insurance » comprise : on la corrige
       seulement quand le panier n'est pas vide, aucune requête sur les visites à vide. */
    var badge = document.querySelector('[data-cart-count]');
    if (badge && !badge.hidden) refreshCartCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
